export const allports = '#00739d';
export const carnation = '#fc6161';
export const purpleHeart = '#6633bc';
export const renoSand = '#9b6310';
export const flushOrange = '#ff8300';
export const caribbeanGreen = '#17eba0';
export const mercury = '#e8e8e8';
export const silver = '#bbbbbb';
export const persianGreen = '#01a982'